import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap';
import classNames from 'classnames';
import logPropError from '../../utils/logPropError';
const errorProps = [
    {
        prop: 'labelsClassName',
        replacement: 'labels.labelClassName',
    },
];
const SteppedProgressBar = props => {
    const { className, variant, labels, mobileBreakpoint, selectedStepNumber, disableFollowingPages: disableFollowingPageIndex, onSelectedChanged, } = props;
    const [disableFollowingPages, setDisableFollowingPages] = useState(disableFollowingPageIndex ? disableFollowingPageIndex : selectedStepNumber);
    logPropError(errorProps, props, 'SteppedProgressBar');
    useEffect(() => {
        if (disableFollowingPageIndex !== undefined) {
            if (disableFollowingPageIndex < selectedStepNumber) {
                console.warn('Invalid component state detected in SteppedProgressBar: can not disable following ' +
                    `pages ${disableFollowingPageIndex} when selectedStep is ${selectedStepNumber}!`);
                return;
            }
            setDisableFollowingPages(disableFollowingPageIndex);
        }
        else if (selectedStepNumber > disableFollowingPages) {
            setDisableFollowingPages(selectedStepNumber);
        }
    }, [disableFollowingPageIndex, selectedStepNumber]);
    const handleSelect = selectedKey => onSelectedChanged(Number(selectedKey));
    const wrapperClasses = classNames('stepped-progress-bar', variant && `variant-${variant}`, mobileBreakpoint && 'mobile-breakpoint', className && className);
    return (_jsx(Nav, Object.assign({ className: wrapperClasses, activeKey: selectedStepNumber, onSelect: handleSelect }, { children: labels.map((labelObject, index) => {
            return (_jsx(Nav.Link, Object.assign({ eventKey: index, disabled: index > disableFollowingPages, as: 'a', className: classNames('step-tab', labelObject.labelWrapperClassName) }, { children: _jsxs("div", Object.assign({ className: 'step-tab-content' }, { children: [_jsx("div", Object.assign({ className: 'item-icon' }, { children: labelObject.icon })), _jsx("div", Object.assign({ className: classNames('item-label', labelObject.labelClassName) }, { children: labelObject.label }))] })) }), index));
        }) })));
};
SteppedProgressBar.VARIANT_CIRCLE = 'circle';
SteppedProgressBar.VARIANT_RECTANGLE = 'rectangle';
SteppedProgressBar.VARIANT_ROADSIGN = 'roadsign';
SteppedProgressBar.defaultProps = {
    selectedStepNumber: 1,
    labels: [],
    onSelectedChanged: () => { },
    variant: 'circle',
    mobileBreakpoint: true,
};
SteppedProgressBar.propTypes = {
    disableFollowingPages: PropTypes.number,
    onSelectedChanged: PropTypes.func.isRequired,
    labels: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        labelClassName: PropTypes.string,
        labelWrapperClassName: PropTypes.string,
    })).isRequired,
    itemClassName: PropTypes.string,
    selectedStepNumber: PropTypes.number.isRequired,
    className: PropTypes.string,
    mobileBreakpoint: PropTypes.bool,
    variant: PropTypes.oneOf([
        SteppedProgressBar.VARIANT_CIRCLE,
        SteppedProgressBar.VARIANT_RECTANGLE,
        SteppedProgressBar.VARIANT_ROADSIGN,
    ]),
};
export default SteppedProgressBar;
